<template>
  <header id="header">
    <div class="container">

      <a class="logo" :href="$options.URLS.HOME[this.lang]" data-attr="logo">
        <img src="@/assets/images/logo.svg" alt="HOSTiQ — лучший хостинг в Украине">
        <h1 v-html="$t('header.tagline')"></h1>
      </a>

      <div class="selects" v-if="currentRouteName === 'template'">
        <lang-select data-attr="lang-select"/>
        <currency-select data-attr="currency-select"/>
      </div>

    </div>
  </header>
</template>

<script>
  import { mapGetters } from "vuex";
  import { SETTINGS_GETTERS } from "@/store/modules/settings";
  import { URLS } from '@/constants';
  import CurrencySelect from '@/shared/components/CurrencySelect/CurrencySelect.vue';
  import LangSelect from '@/shared/components/LangSelect/LangSelect.vue';

  export default {
    name: 'MainHeader',
    URLS,
    components: {
      CurrencySelect,
      LangSelect
    },
    component: {
      LangSelect,
    },
    async mounted() {
      if (!this.lang) {
        this.lang =  await this.setLang();
      };
    },
    computed: {
      ...mapGetters('settings', { lang: SETTINGS_GETTERS.LANG }),
      currentRouteName() {
        return this.$route.name;
      },
    }
  }
</script>

<style lang="scss">

  header {
    width: 100%;
    background-color: $base-bg-header;
    position: relative;
    z-index: 2;
    padding: 22px 0 28px;
    top: 0;
    transition: all .7s ease-in-out;

    & .container {
      max-width: 100%;
      padding-left: 30px;
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
    }

    & .logo {
      display: inline-flex;
      align-items: center;
      text-decoration: none;
      transition: $transition;

      &:hover {
        opacity: .8;
      }

      &:after {
        display: none;
      }
    }

    & h1 {
      color: #3fc9ff;
      font-weight: 700;
      font-size: 16px;
      padding-left: 20px;
      padding-top: 11px;
      margin-bottom: 0;

      @media (max-width: $tablet) {
        display: none;
      }
    }

    .selects {
      display: flex;
      align-items: center;
      padding-left: 20px;
      margin-top: 0;

      @media (max-width: 450px) {
        padding-left: 0;
        width: 100%;
        padding-top: 10px;
      }

      .global-select{

        &:not(:last-child) {
          margin-right: 20px;
        }

        &, .theme--light.v-list {
          background-color: #494A4D;
        }
      }
    }
  }
</style>
